export default {"src":"/_next/static/media/CarpalTunnelSyndrome.5e1fe05d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};